import { all, takeEvery, put, call } from "@redux-saga/core/effects";
import { AnyAction } from "redux";
import { setLoading } from "../../layouts/main-layout/MainLayout.reducer";
import { InspectionAssignmentOverviewDTO } from "../../../common/types/common.dto.types";
import { GETASSIGNEDINSPECTIONS } from "./InspectionAssignmentOverviewPage.action";
import { InspectionAssignmentOverviewPageType } from "./InspectionAssignmentOverviewPage.types";
import { inspectionAssignmentOverviewReducerActions } from "./InspectionAssignmentOverviewPage.reducer";
import { ActionResponseType } from "../../../common/types/common.types";
import {
  getAssignedInspectionsApi,
  getAssignedInspectionStatisticsApi,
} from "./InspectionAssignmentOverviewPage.api";
import { callAllApiRequest } from "../../../core/api/apiClient.service";

// ==============================|| VIEWS - PAGES - INSPECTION ASSIGNMENT OVERVIEW - SAGA ||============================== //

const getAssignedInspectionsWatcher = function* (): any {
  yield takeEvery(GETASSIGNEDINSPECTIONS, function* (action: AnyAction): any {
    yield put(setLoading(true));

    const searchParameter: InspectionAssignmentOverviewDTO =
      action.payload?.searchParameter;

    const getAssignedInspections: Promise<ActionResponseType> =
      getAssignedInspectionsApi(searchParameter);
    const getAssignedInspectionStatistics: Promise<ActionResponseType> =
      getAssignedInspectionStatisticsApi(searchParameter);

    const result = yield call(
      async () =>
        await callAllApiRequest([
          getAssignedInspections,
          getAssignedInspectionStatistics,
        ])
    );

    if (result[0]?.Data?.PageData == null && !result[0]?.Data?.PageData) {
      // TODO document why this block is empty
    } else {
      yield put(
        inspectionAssignmentOverviewReducerActions.setAssignedInspections({
          Data: {
            ...result[0]?.Data?.PageData,
          },

          InspectionAssignmentOverviewStatusSummary:
            result[1]?.Data?.InspectionAssignmentOverviewStatusSummary,
          InspectionAssessmentSummary:
            result[1]?.Data?.InspectionAssessmentSummary,
          InspectionAssignmentOverviewYears:
            result[1]?.Data?.InspectionAssignmentOverviewYears,

          InspectionSiteList: result[1]?.Data?.InspectionSiteList,
        } as InspectionAssignmentOverviewPageType)
      );

      yield put(
        inspectionAssignmentOverviewReducerActions.setInspectionAssignmentOverviewSearchParameter(
          {
            ...searchParameter,
            InspectionStatusId: result[0]?.Data?.InspectionStatusId,
            AssessmentTypeGroupId: result[0]?.Data?.AssessmentTypeGroupId,
          }
        )
      );
    }

    yield put(setLoading(false));
  });
};

const inspectionAssignmentOverviewSaga = function* () {
  yield all([getAssignedInspectionsWatcher()]);
};

export default inspectionAssignmentOverviewSaga;
